import React, { useState } from "react";

const About = ({ data }) => {
  const [profileImageError, setProfileImageError] = useState(false);

  if (!data) {
    return null;
  }

  const name = data.name || "";
  const profilepic = data.image ? "images/" + data.image : "";
  const bio = data.bio || "";
  const address = data.address || {};
  const street = address.street || "";
  const city = address.city || "";
  const state = address.state || "";
  const zip = address.zip || "";
  const phone = data.phone || "";
  const email = data.email || "";
  //const resumeDownload = data.resumedownload;
  const linkedin = Array.isArray(data.social)
    ? data.social.find((s) => s.name?.toLowerCase() === "linkedin")
    : null;

  return (
    <section id="about">
      <div className="row">
        <div className="two columns">
          {profilepic && !profileImageError ? (
            <img
              className="profile-pic"
              src={profilepic}
              alt={name ? `${name} headshot` : "Profile"}
              onError={() => setProfileImageError(true)}
            />
          ) : (
            <div
              className="profile-pic profile-pic-fallback"
              aria-hidden="true"
              title={name || "Profile"}
            >
              {name ? name.charAt(0).toUpperCase() : "?"}
            </div>
          )}
        </div>
        <div className="nine columns main-col">
          <h2>About</h2>

          <p>{bio}</p>

          <div className="row about-columns">
            <div className="columns contact-details">
              <h3 className="about-subheading">Quick info</h3>
              <ul className="about-facts">
                {(street || city || state || zip) && (
                  <li>
                    <strong>Based</strong>: {[street, city, state, zip].filter(Boolean).join(", ")}
                  </li>
                )}
                {email && (
                  <li>
                    <strong>Email</strong>: <a href={`mailto:${email}`}>{email}</a>
                  </li>
                )}
                {phone && (
                  <li>
                    <strong>Phone</strong>: <a href={`tel:${phone}`}>{phone}</a>
                  </li>
                )}
              </ul>
            </div>

            <div className="columns download">
              <h3 className="about-subheading">Links</h3>
              <div className="about-links">
                {/* {resumeDownload && (
                  <a href={resumeDownload} className="button">
                    <i className="fa fa-download"></i>Resume (PDF)
                  </a>
                )} */}
                {linkedin?.url && (
                  <a
                    href={linkedin.url}
                    className="button button-secondary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-linkedin"></i>LinkedIn
                  </a>
                )}
                {/* {website && (
                  <a
                    href={website}
                    className="button button-secondary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-globe"></i>Website
                  </a>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
